



// import React, { useState, useEffect, useRef } from "react";
// import "./LandingSideBar2.css";
// import { Link, useLocation, useNavigate } from "react-router-dom"; // Add useNavigate 

// import MenuIcon from "@mui/icons-material/Menu";
// import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import LocationOnIcon from "@mui/icons-material/LocationOn";

// // Sidebar icons
// import HomeIcon from "@mui/icons-material/Home";
// import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
// import FastfoodIcon from "@mui/icons-material/Fastfood";
// import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";

// import {
//   Building,
//   Settings,
//   Utensils,
//   Package,
//   ShoppingBag,
//   ChefHat,
//   Table,
//   Users,
//   User,
//   Tag,
//   Star,
//   Headphones,
//   FileText,
//   Bell,
//   BarChart,
//   Store,
//   UserCog,
//   UsersRound
// } from "lucide-react";

// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Paper,
// } from "@mui/material";

// import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";

// /* =========================
//    MENU CONFIGURATION
// ========================= */

// const BACKEND_MODULES = {
//   PLATFORM_ACCESS: "PLATFORM_ACCESS",
//   VENDOR_PROFILE: "VENDOR_PROFILE",
//   MENU_MANAGEMENT: "MENU_MANAGEMENT",
//   ORDER_MANAGEMENT: "ORDER_MANAGEMENT",
//   TABLE_ORDERS: "TABLE_ORDERS",
//   DELIVERY: "DELIVERY",
//   INVENTORY_MANAGEMENT: "INVENTORY_MANAGEMENT",
//   CHEF_MANAGEMENT: "CHEF_MANAGEMENT",
//   TEAM_MANAGEMENT: "TEAM_MANAGEMENT",
//   PROMOTIONS: "PROMOTIONS",
//   REPORTS: "REPORTS",
//   SUPPORT: "SUPPORT",
//   ACCOUNT_HISTORY: "ACCOUNT_HISTORY",
//   NOTIFICATIONS: "NOTIFICATIONS",
// };

// // Updated enumToMenuItemMap with Services dropdown  ACCOUNT_HISTORY: "ACCOUNT_HISTORY",
// const enumToMenuItemMap = {
//   Dashboard: {
//     text: "Dashboard",
//     icon: HomeIcon,
//     route: "/homes",
//     type: "link"
//   },
//   Company: {
//     text: "Subscription",
//     icon: Building,
//     route: "/Foodsubscription",
//     type: "link"
//   },
//   Client_Management: {
//     text: "Client Management",
//     icon: Settings,
//     route: "/foodclientmanagement",
//     type: "link"
//   },


//   Order_Management: {
//     text: "Order Management",
//     icon: ShoppingBag,
//     route: "/foodordermanagement",
//     type: "link"
//   },


//   Menu_Management: {
//     text: "Menu Management",
//     icon: ChefHat,
//     route: "/foodmenumanagement",
//     type: "link"
//   },

//   user_management: {
//     text: "User Management",
//     icon: Users,
//     route: "/userdetails",
//     type: "link"
//   },
//   Account_History: {
//     text: "Account Management",
//     icon: UserCog,
//     route: "/foodaccountmanagement",
//     type: "link"
//   },

//   Settings_Controls: {
//     text: "Setting & Control",
//     icon: Package,
//     route: "/foodsettingmanagement",
//     type: "link"
//   },
//   Team_Managment: {
//     text: "Team Management",
//     icon: UsersRound,
//     route: "/teamlanding",
//     type: "link"
//   },

//   Promotions_Discounts: {
//     text: "Promotions & Marketing",
//     icon: Tag,
//     route: "/foodpramotions",
//     type: "link"
//   },
//   Support_system: {
//     text: "Support System",
//     icon: Star,
//     route: "/foodcare",
//     type: "link"
//   },

//   Report_Analysis: {
//     text: "Report & Analysis",
//     icon: BarChart,
//     route: "/foodreportmanagement",
//     type: "link"
//   },
// };

// /* =========================
//    PREMIUM PROFESSIONAL LAYOUT
// ========================= */

// const PremiumProfessionalLayout = ({ children }) => {
//   const location = useLocation();
//   const navigate = useNavigate(); // Add useNavigate hook
//   const sidebarRef = useRef(null);

//   const [isOpen, setIsOpen] = useState(true);
//   const [isHovering, setIsHovering] = useState(false);
//   const [locationPopup, setLocationPopup] = useState(false);
//   const [profileDropdown, setProfileDropdown] = useState(false);
//   const [openDropdowns, setOpenDropdowns] = useState({});

//   const [currentLocation, setCurrentLocation] = useState(null);
//   const [mapCenter, setMapCenter] = useState({
//     lat: 28.6139,
//     lng: 77.209,
//   });

//   const [address, setAddress] = useState("");
//   const [savedAddresses, setSavedAddresses] = useState([]);
//   const [selectedAddress, setSelectedAddress] = useState("");

//   // Company name state
//   const [companyName] = useState("Maamas Kitchen"); // You can make this dynamic later

//   /* =========================
//      HOVER TIMER REF
//   ========================= */
//   const hoverTimerRef = useRef(null);
//   const [allowedModules, setAllowedModules] = useState([]);
//   /* =========================
//      LOAD SAVED DATA
//   ========================= */
//   useEffect(() => {
//     const saved = JSON.parse(localStorage.getItem("savedAddresses")) || [];
//     const selected = localStorage.getItem("selectedAddress") || "";
//     setSavedAddresses(saved);
//     setSelectedAddress(selected);
//   }, []);

//   /* =========================
//      CLEANUP TIMER
//   ========================= */
//   useEffect(() => {
//     return () => {
//       if (hoverTimerRef.current) {
//         clearTimeout(hoverTimerRef.current);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     const role = localStorage.getItem("role");
//     const storedModulesRaw = localStorage.getItem("businessModules");

//     let storedModules = [];

//     try {
//       storedModules = storedModulesRaw ? JSON.parse(storedModulesRaw) : [];
//     } catch (e) {
//       console.error("❌ Failed to parse modules:", e);
//     }

//     console.log("👤 Role:", role);
//     console.log("📦 Modules:", storedModules);

//     // ✅ SUPER DUPER ADMIN → SHOW ALL
//     if (role === "ROLE_SUPER_DUPER_ADMIN") {
//       setAllowedModules(Object.entries(enumToMenuItemMap));
//       console.log("🟢 SUPER DUPER ADMIN → showing ALL modules");
//       return;
//     }

//     // ✅ NORMAL USERS → FILTER MODULES
//     const normalizeModule = (name) => {
//       const map = {
//         "subscription": "Company"
//       };
//       return map[name] || name;
//     };

//     const filtered = Object.entries(enumToMenuItemMap).filter(([key]) =>
//       storedModules
//         .map(m => normalizeModule(m).toLowerCase())
//         .includes(key.toLowerCase())
//     );

//     setAllowedModules(filtered);

//   }, []);


//   const renderMenuItems = () => {
//     return allowedModules.map(([key, item]) => {
//       const Icon = item.icon;

//       return (
//         <li
//           key={key}
//           className={`pp-menu-item ${location.pathname === item.route ? "pp-active" : ""
//             }`}
//         >
//           <Link to={item.route} className="pp-menu-link">
//             <Icon />
//             {(isOpen || isHovering) && <span>{item.text}</span>}
//           </Link>
//         </li>
//       );
//     });
//   };
//   /* =========================
//      CURRENT LOCATION
//   ========================= */
//   const handleUseCurrentLocation = () => {
//     navigator.geolocation.getCurrentPosition((position) => {
//       const coords = {
//         lat: position.coords.latitude,
//         lng: position.coords.longitude,
//       };
//       setCurrentLocation(coords);
//       setMapCenter(coords);
//       setAddress("Current Location");
//     });
//   };

//   /* =========================
//      MAP CLICK
//   ========================= */
//   const MapClickHandler = () => {
//     useMapEvents({
//       click(e) {
//         setCurrentLocation(e.latlng);
//         setMapCenter(e.latlng);
//       },
//     });
//     return null;
//   };

//   /* =========================
//      SAVE ADDRESS
//   ========================= */
//   const handleSaveAddress = () => {
//     if (!currentLocation) return;

//     const newAddress = {
//       address,
//       coords: currentLocation,
//       type: "Saved",
//     };

//     const updated = [...savedAddresses, newAddress];
//     setSavedAddresses(updated);

//     localStorage.setItem("savedAddresses", JSON.stringify(updated));
//     localStorage.setItem("selectedAddress", address);

//     setSelectedAddress(address);
//     setLocationPopup(false);
//   };

//   /* =========================
//      TOGGLE DROPDOWN
//   ========================= */
//   const toggleDropdown = (key) => {
//     setOpenDropdowns(prev => ({
//       ...prev,
//       [key]: !prev[key]
//     }));
//   };

//   /* =========================
//      CHECK IF CHILD IS ACTIVE
//   ========================= */
//   const isChildActive = (children) => {
//     return children.some(child => location.pathname === child.route);
//   };

//   /* =========================
//      SIDEBAR HOVER HANDLERS
//   ========================= */
//   const handleSidebarMouseEnter = () => {
//     if (!isOpen) {
//       hoverTimerRef.current = setTimeout(() => {
//         setIsHovering(true);
//       }, 300); // 300ms delay before expanding
//     }
//   };

//   const handleSidebarMouseLeave = () => {
//     if (hoverTimerRef.current) {
//       clearTimeout(hoverTimerRef.current);
//     }
//     setIsHovering(false);
//   };

//   /* =========================
//      GET SIDEBAR CLASS
//   ========================= */
//   const getSidebarClass = () => {
//     let baseClass = "pp-sidebar";
//     baseClass += isOpen ? " pp-open" : " pp-closed";
//     baseClass += isHovering && !isOpen ? " pp-hover-expand" : "";
//     return baseClass;
//   };

//   /* =========================
//      HANDLE LOGOUT
//   ========================= */
//   const handleLogout = () => {
//     // Clear authentication data from localStorage
//     localStorage.removeItem("authToken");
//     localStorage.removeItem("vendorId");
//     // Close profile dropdown
//     setProfileDropdown(false);
//     // Navigate to login page
//     navigate("/");
//   };

//   /* =========================
//      RENDER MENU ITEMS
//   ========================= */


//   return (
//     <div className="pp-layout">
//       {/* NAVBAR */}
//       <header className="pp-top-navbar">
//         <div className="pp-nav-left">
//           <MenuIcon
//             className="pp-nav-icon"
//             onClick={() => setIsOpen(!isOpen)}
//           />
//           <h2 className="pp-logo-text">
//             <span className="pp-black">M</span>
//             <span className="pp-red">aa</span>
//             <span className="pp-black">maas</span>
//           </h2>
//         </div>

//         {/* LOCATION */}
//         {/* <div className="pp-nav-center">
//           <button
//             className="pp-location-btn"
//             onClick={() => setLocationPopup(true)}
//           >
//             <LocationOnIcon />
//             {selectedAddress || "Select Location"}
//           </button>
//         </div> */}

//         {/* RIGHT */}
//         <div className="pp-nav-right">
//           <NotificationsOutlinedIcon className="pp-nav-icon" />

//           <div className="pp-profile-wrapper">
//             <AccountCircleIcon
//               className="pp-profile-icon"
//               onClick={() => setProfileDropdown(!profileDropdown)}
//             />
//             {profileDropdown && (
//               <div className="pp-profile-dropdown">
//                 {/* <div className="pp-dropdown-item">Subscription</div> */}
//                 <div className="pp-dropdown-item" onClick={handleLogout}>Logout</div> {/* Add onClick handler */}
//               </div>
//             )}
//           </div>
//         </div>
//       </header>

//       {/* LOCATION POPUP */}
//       {locationPopup && (
//         <div className="pp-location-modal">
//           <Paper
//             elevation={4}
//             sx={{
//               width: "900px",
//               display: "flex",
//               overflow: "hidden",
//               borderRadius: "12px",
//             }}
//           >
//             <Box sx={{ width: "40%", p: 3 }}>
//               {/* <Typography variant="h6" mb={2}>
//                 Select Location
//               </Typography> */}

//               <Button
//                 variant="contained"
//                 fullWidth
//                 onClick={handleUseCurrentLocation}
//                 sx={{ mb: 2 }}
//               >
//                 Use My Current Location
//               </Button>

//               <TextField
//                 fullWidth
//                 placeholder="Search address"
//                 value={address}
//                 onChange={(e) => setAddress(e.target.value)}
//                 sx={{ mb: 2 }}
//               />

//               {currentLocation && (
//                 <Button fullWidth variant="contained" onClick={handleSaveAddress}>
//                   Save Address
//                 </Button>
//               )}
//             </Box>

//             <Box sx={{ width: "60%" }}>
//               <MapContainer
//                 center={[mapCenter.lat, mapCenter.lng]}
//                 zoom={15}
//                 style={{ height: "500px", width: "100%" }}
//               >
//                 <TileLayer
//                   attribution="&copy; OpenStreetMap"
//                   url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                 />
//                 {currentLocation && (
//                   <Marker position={[currentLocation.lat, currentLocation.lng]} />
//                 )}
//                 <MapClickHandler />
//               </MapContainer>
//             </Box>
//           </Paper>
//         </div>
//       )}

//       {/* SIDEBAR */}
//       <div
//         ref={sidebarRef}
//         className={getSidebarClass()}
//         onMouseEnter={handleSidebarMouseEnter}
//         onMouseLeave={handleSidebarMouseLeave}
//       >
//         {/* Company Name Section - Always Visible */}
//         {/* <div className="pp-company-section">
//           <div className="pp-company-icon">
//             <Store />
//           </div>
//           <div className={`pp-company-name ${!(isOpen || isHovering) ? 'pp-company-name-hidden' : ''}`}>
//             {companyName}
//           </div>
//         </div> */}

//         <ul className="pp-menu">
//           {renderMenuItems()}
//         </ul>
//       </div>

//       {/* CONTENT */}
//       <div className={`pp-content ${(isOpen || isHovering) ? "pp-content-shift" : ""}`}>
//         {children}
//       </div>
//     </div>
//   );
// };

// export default PremiumProfessionalLayout;










import React, { useState, useEffect, useRef } from "react";
import "./Mainsidebar.css";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Added useNavigate


import MenuIcon from "@mui/icons-material/Menu";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";

// Sidebar icons
import HomeIcon from "@mui/icons-material/Home";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import webSocketService from "../features/auth/services/WebSocketService .jsx ";

import LogoutIcon from "@mui/icons-material/Logout";
import { MapPin, } from "lucide-react";

import {
  Building,
  Settings,
  Utensils,
  Package,
  ShoppingBag,
  Wallet,
  ChefHat,
  Table,
  Users,
  UserCog,
  UsersRound,
  User,
  Tag,
  Star,
  Headphones,
  FileText,
  Bell,
  BarChart,
  Store,
  Heart,
  HelpCircle,
  Gift // Added Gift icon for Rewards & Coupons
} from "lucide-react";
import { FaMapMarkerAlt, FaSearch, FaBars, FaTimes, } from "react-icons/fa";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
} from "@mui/material";

import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";



const BACKEND_MODULES = {
  PLATFORM_ACCESS: "PLATFORM_ACCESS",
  VENDOR_PROFILE: "VENDOR_PROFILE",
  MENU_MANAGEMENT: "MENU_MANAGEMENT",
  ORDER_MANAGEMENT: "ORDER_MANAGEMENT",
  TABLE_ORDERS: "TABLE_ORDERS",
  DELIVERY: "DELIVERY",
  INVENTORY_MANAGEMENT: "INVENTORY_MANAGEMENT",
  CHEF_MANAGEMENT: "CHEF_MANAGEMENT",
  TEAM_MANAGEMENT: "TEAM_MANAGEMENT",
  PROMOTIONS: "PROMOTIONS",
  REPORTS: "REPORTS",
  SUPPORT: "SUPPORT",
  ACCOUNT_HISTORY: "ACCOUNT_HISTORY",
  NOTIFICATIONS: "NOTIFICATIONS",
};

// Updated enumToMenuItemMap with Services dropdown
const enumToMenuItemMap = {
  Dashboard: {
    text: "Dashboard",
    icon: HomeIcon,
    route: "/homes",
    type: "link"
  },
  Company: {
    text: "Subscription",
    icon: Building,
    route: "/Foodsubscription",
    type: "link"
  },
  Client_Management: {
    text: "Client Management",
    icon: Settings,
    route: "/foodclientmanagement",
    type: "link"
  },


  Order_Management: {
    text: "Order Management",
    icon: ShoppingBag,
    route: "/foodordermanagement",
    type: "link"
  },


  Menu_Management: {
    text: "Menu Management",
    icon: ChefHat,
    route: "/foodmenumanagement",
    type: "link"
  },

  user_management: {
    text: "User Management",
    icon: Users,
    route: "/userdetails",
    type: "link"
  },
  Account_History: {
    text: "Account Management",
    icon: UserCog,
    route: "/foodaccountmanagement",
    type: "link"
  },

  Settings_Controls: {
    text: "Setting & Control",
    icon: Package,
    route: "/foodsettingmanagement",
    type: "link"
  },
  Team_Managment: {
    text: "Team Management",
    icon: UsersRound,
    route: "/teamlanding",
    type: "link"
  },

  Promotions_Discounts: {
    text: "Promotions & Marketing",
    icon: Tag,
    route: "/foodpramotions",
    type: "link"
  },
  Support_system: {
    text: "Support System",
    icon: Star,
    route: "/foodcare",
    type: "link"
  },
  // Rivew_retings:{
  //   text:'Review Retings',
  //   icon: Star,
  //   route:"/retting",
  //   type:'link',
  // },

  Report_Analysis: {
    text: "Report & Analysis",
    icon: BarChart,
    route: "/foodreportmanagement",
    type: "link"
  },
};

/* =========================
   PREMIUM PROFESSIONAL LAYOUT REAL TIME USED DATA NOT USED IN THAT VACTINAL VARIO
========================= */



const PremiumProfessionalLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate(); // Added useNavigate
  const profileRef = useRef(null);

  const sidebarRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [scrolled, setScrolled] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isOpen, setIsOpen] = useState(() => {
    const savedState = localStorage.getItem('sidebar');
    // Default to true (open) if no saved state
    return savedState === 'open' ? true : true;
  });
  const [isHovering, setIsHovering] = useState(false);
  const [locationPopup, setLocationPopup] = useState(false);
  const [profileDropdown, setProfileDropdown] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});

  const [currentLocation, setCurrentLocation] = useState(null);
  const [mapCenter, setMapCenter] = useState({
    lat: 28.6139,
    lng: 77.209,
  });

  const [address, setAddress] = useState("");


  // LOCATION STATES
  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [locationError, setLocationError] = useState("");
  const [isLocating, setIsLocating] = useState(false);
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [setError] = useState("");


  // Map States
  const [showMapPopup, setShowMapPopup] = useState(false);
  const [mapSelectedLocation, setMapSelectedLocation] = useState(null);
  const [mapAddress, setMapAddress] = useState("");
  const [addressTitle, setAddressTitle] = useState("");
  const [isMapLoading, setIsMapLoading] = useState(false);
  const mapRef = useRef(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // Company name state
  const [companyName, setCompanyName] = useState(
    localStorage.getItem("companyName") || ""
  );

  const [companyLogo, setCompanyLogo] = useState(
    localStorage.getItem("companyLogo") || ""
  );
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  // Helper functions to get customer data
  const getCustomerId = () => {
    return localStorage.getItem("customerId");
  };

  const getAuthToken = () => {
    return localStorage.getItem("authToken");
  };

  // Add this useEffect to save sidebar state to localStorage
  useEffect(() => {
    // Save to localStorage whenever isOpen changes
    localStorage.setItem('sidebar', isOpen ? 'open' : 'closed');
    //console.log('Sidebar state saved to localStorage:', isOpen ? 'open' : 'closed');
  }, [isOpen]);
  /* =========================
      HANDLE LOGOUT FUNCTION
   ========================= */
  const handleLogout = () => {

    // webSocketService.disconnect();
    // Clear all localStorage items
    localStorage.clear();

    // Navigate to login page
    navigate("/");

    // Close profile dropdown
    setProfileDropdown(false);
  };

  /* =========================
     HANDLE SUBSCRIPTION NAVIGATION
  ========================= */
  const handleSubscription = () => {
    navigate("/landingpagesubscription");
    setProfileDropdown(false);
  };

  const handleGetCurrentLocationFromMap = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(async (position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      setIsMapLoading(true);

      try {
        if (window.currentMap) {
          window.currentMap.setView([lat, lng], 16);
        }

        if (window.currentMarker) {
          window.currentMarker.setLatLng([lat, lng]);
        } else if (window.L && window.currentMap) {
          window.currentMarker = window.L.marker([lat, lng]).addTo(window.currentMap);
        }

        setMapSelectedLocation([lat, lng]);

        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
        );

        const data = await res.json();

        const address = data.display_name;

        // 🔥 Correct city extraction
        let city =
          data.address?.city ||
          data.address?.municipality ||
          data.address?.town ||
          data.address?.village ||
          "Hyderabad";

        setMapAddress(address);

        const customerId = getCustomerId();
        const token = getAuthToken();

        const requestData = {
          customerId: customerId,
          latitude: lat,
          longitude: lng,
          address: address,
          city: city,
        };



        const response = await fetch(
          "https://backend.maamaas.com/subscription/api/user/curret/location/update",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestData),
          }
        );

        const result = await response.json();


      } catch (error) {
        // console.error("Location Save Error:", error);
      }

      setIsMapLoading(false);
    });
  };


  /* =========================
     HOVER TIMER REF
  ========================= */
  const hoverTimerRef = useRef(null);

  /* =========================
     LOAD SAVED DATA
  ========================= */

  useEffect(() => {
    const saved = localStorage.getItem("selectedAddress");
    if (saved) {
      setSelectedAddress(saved);
    }
  }, []);



  useEffect(() => {
    // Check if user is logged in by checking for customerId or vendorId
    const customerId = getCustomerId();
    const vendorId = localStorage.getItem("vendorId");
    const userRole = localStorage.getItem("role");

    const loggedIn = !!(customerId || vendorId);
    setIsLoggedIn(loggedIn);



    if (loggedIn) {
      fetchUserSavedLocation();
      fetchAllCustomerAddresses();
    }
  }, []);

  useEffect(() => {
    if (showLocationPopup) {
      fetchUserSavedLocation();
      fetchAllCustomerAddresses();
    }
  }, [showLocationPopup]);


  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("savedAddresses")) || [];
    const selected = localStorage.getItem("selectedAddress") || "";
    setSavedAddresses(saved);
    setSelectedAddress(selected);
  }, []);




  const fetchUserSavedLocation = async () => {
    const token = getAuthToken();
    const customerId = getCustomerId();

    if (!token || !customerId) return;

    try {
      const res = await fetch(
        `https://backend.maamaas.com/subscription/api/customer/get/current/location?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // if (!res.ok) {
      //   console.error("Failed to fetch location:", res.status);
      //   return;
      // }

      const text = await res.text();
      if (!text) {
        console.warn("No saved location found");
        return;
      }

      const data = JSON.parse(text);

      if (data?.address) {
        setSelectedAddress(data.address);
        // Save to localStorage for quick access
        localStorage.setItem(`currentLocation_${customerId}`, JSON.stringify({
          full: data.address,
          lat: data.latitude,
          lng: data.longitude
        }));
      }
    } catch (err) {
      // console.error("fetchUserSavedLocation error:", err);
    }
  };

  // Fetch all customer addresses
  const fetchAllCustomerAddresses = async () => {
    const token = getAuthToken();
    const customerId = getCustomerId();

    if (!token || !customerId) return;

    try {
      const res = await fetch(
        `https://backend.maamaas.com/subscription/api/customer/get/address?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // if (!res.ok) {
      //   console.error("Failed to fetch addresses:", res.status);
      //   return;
      // }

      const data = await res.json();

      if (Array.isArray(data)) {
        // Transform API response to match our format
        const formattedAddresses = data.map(addr => ({
          title: addr.title || addr.addressType || "Saved Address",
          full: addr.address,
          lat: addr.latitude,
          lng: addr.longitude,
          id: addr.id
        }));

        setSavedAddresses(formattedAddresses);
        localStorage.setItem(`savedAddresses_${customerId}`, JSON.stringify(formattedAddresses));
      }
    } catch (err) {
      // console.error("fetchAllCustomerAddresses error:", err);
    }
  };

  // Initialize Map when popup opens
  useEffect(() => {
    if (showMapPopup) {
      if (!document.querySelector('link[href*="leaflet"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
        document.head.appendChild(link);
      }

      if (!window.L) {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
        script.onload = initializeMap;
        document.head.appendChild(script);
      } else {
        initializeMap();
      }
    }
  }, [showMapPopup]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const initializeMap = () => {
    if (!mapRef.current || !window.L) return;

    if (window.currentMap) {
      window.currentMap.remove();
    }

    const defaultLocation = [40.7128, -74.0060]; // New York
    const map = window.L.map(mapRef.current).setView(defaultLocation, 13);
    window.currentMap = map;

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(map);

    map.on('click', (e) => {
      const clickedLocation = [e.latlng.lat, e.latlng.lng];
      setMapSelectedLocation(clickedLocation);
      updateMarker(clickedLocation, map);
      getAddressFromCoordinates(clickedLocation);
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = [position.coords.latitude, position.coords.longitude];
          map.setView(userLocation, 15);
          setMapSelectedLocation(userLocation);
          updateMarker(userLocation, map);
          getAddressFromCoordinates(userLocation);
        },
        () => {
          setMapSelectedLocation(defaultLocation);
          updateMarker(defaultLocation, map);
          getAddressFromCoordinates(defaultLocation);
        }
      );
    }
  };

  const updateMarker = (location, map) => {
    if (window.currentMarker) {
      window.currentMarker.remove();
    }

    const marker = window.L.marker(location, { draggable: true }).addTo(map);
    window.currentMarker = marker;

    marker.on('dragend', (e) => {
      const draggedLocation = [e.target.getLatLng().lat, e.target.getLatLng().lng];
      setMapSelectedLocation(draggedLocation);
      getAddressFromCoordinates(draggedLocation);
    });
  };

  const getAddressFromCoordinates = async (location) => {
    setIsMapLoading(true);
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location[0]},${location[1]}&key=`
      );
      const data = await response.json();

      if (data.status === "OK" && data.results.length > 0) {
        setMapAddress(data.results[0].formatted_address);
      } else {
        setMapAddress("Address not found");
      }
    } catch (error) {
      // console.error("Error getting address:", error);
      setMapAddress("Error getting address");
    } finally {
      setIsMapLoading(false);
    }
  };

  const handleSaveAddressFromMap = async () => {
    if (!mapSelectedLocation || !mapAddress) return;

    const customerId = getCustomerId();
    const token = getAuthToken();

    if (!customerId || !token) {
      alert("Please login to save address");
      return;
    }

    const newAddress = {
      title: addressTitle || "Custom Location",
      full: mapAddress,
      lat: mapSelectedLocation[0],
      lng: mapSelectedLocation[1],
    };

    // 🔥 Get city from reverse geocode using lat/lng
    let city = "";

    try {
      const geoRes = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${newAddress.lat}&lon=${newAddress.lng}`
      );

      const geoData = await geoRes.json();

      city =
        geoData.address?.city ||
        geoData.address?.town ||
        geoData.address?.municipality ||
        geoData.address?.village ||
        geoData.address?.state_district ||
        geoData.address?.county ||
        "";

    } catch (err) {
      // console.error("City extraction failed:", err);
    }

    // Add to local state
    setSavedAddresses((prev) => [newAddress, ...prev]);
    setSelectedAddress(mapAddress);

    try {
      const requestData = {
        customerId: customerId,
        latitude: newAddress.lat,
        longitude: newAddress.lng,
        address: newAddress.full,
        city: city,
      };



      const response = await fetch(
        "https://backend.maamaas.com/subscription/api/user/curret/location/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        fetchAllCustomerAddresses();
        window.location.reload();
      }

    } catch (error) {
      // console.error("Error saving address:", error);
    }

    setShowMapPopup(false);
    setShowLocationPopup(false);
    setAddressTitle("");
    setMapSelectedLocation(null);
    setMapAddress("");
  };

  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      setLocationError("Geolocation not supported");
      return;
    }

    const customerId = getCustomerId();
    const token = getAuthToken();

    if (!customerId || !token) {
      alert("Please login to save address");
      return;
    }

    setIsLocating(true);
    setLocationError("");

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        try {
          // Get address from lat lng
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
          );

          const data = await res.json();
          const address = data.display_name;

          setSelectedAddress(address);
          localStorage.setItem("selectedAddress", address);

          // 🔥 SAVE LOCATION TO BACKEND
          await fetch(
            "https://backend.maamaas.com/subscription/api/user/curret/location/update",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                customerId: customerId,
                latitude: lat,
                longitude: lng,
                address: address,
              }),
            }
          );

          setIsLocating(false);
          setShowLocationPopup(false);
        } catch (err) {
          // console.error(err);
          setLocationError("Unable to fetch address");
          setIsLocating(false);
        }
      },
      () => {
        setLocationError("Location permission denied");
        setIsLocating(false);
      }
    );
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) {
      //console.log("User ID not found");
      return;
    }

    const fetchName = async () => {
      try {
        const response = await fetch(
          `https://backend.maamaas.com/subscription/api/user/getprofile/${userId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );

        if (!response.ok) throw new Error("Failed to fetch");

        const data = await response.json();

        if (data.userName) {
          setCompanyName(data.userName); // ✅ UI update instantly
          localStorage.setItem("companyName", data.userName);
        }
      } catch (err) {
        //console.log(err);
      }
    };

    fetchName();
  }, []);


  const handleAddressSearch = async () => {
    if (!searchQuery.trim()) return;

    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          searchQuery
        )}&limit=5`
      );

      const data = await res.json();

      if (data.length > 0) {
        const address = data[0].display_name;

        setSelectedAddress(address);
        localStorage.setItem("selectedAddress", address);

        setShowLocationPopup(false);
        setSearchQuery("");
      } else {
        setLocationError("Address not found");
      }
    } catch (err) {
      setLocationError("Search failed");
    }
  };
  /* =========================
     CLEANUP TIMER
  ========================= */
  useEffect(() => {
    return () => {
      if (hoverTimerRef.current) {
        clearTimeout(hoverTimerRef.current);
      }
    };
  }, []);

  /* =========================
     CURRENT LOCATION
  ========================= */
  const handleUseCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const coords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      setCurrentLocation(coords);
      setMapCenter(coords);
      setAddress("Current Location");
    });
  };

  /* =========================
     MAP CLICK
  ========================= */
  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        setCurrentLocation(e.latlng);
        setMapCenter(e.latlng);
      },
    });
    return null;
  };

  /* =========================
     SAVE ADDRESS
  ========================= */
  const handleSaveAddress = () => {
    if (!currentLocation) return;

    const newAddress = {
      address,
      coords: currentLocation,
      type: "Saved",
    };

    const updated = [...savedAddresses, newAddress];
    setSavedAddresses(updated);

    localStorage.setItem("savedAddresses", JSON.stringify(updated));
    localStorage.setItem("selectedAddress", address);

    setSelectedAddress(address);
    setLocationPopup(false);
  };

  /* =========================
     TOGGLE DROPDOWN
  ========================= */
  const toggleDropdown = (key) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };



  const handleDeleteAccount = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) {
      setError("No userId found");
      return;
    }

    // Show confirmation dialog
    const isConfirmed = window.confirm("Are you sure you want to delete your account? This action cannot be undone and all your data will be permanently lost.");

    if (!isConfirmed) {
      return; // User cancelled the deletion
    }

    try {
      const response = await fetch(
        `https://backend.maamaas.com/subscription/api/user/delete/account/${userId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );

      if (response.ok) {
        alert("Account deleted successfully");
        localStorage.clear();
        window.location.href = "/";
      } else {
        const errMsg = await response.text();
        throw new Error(errMsg || "Failed to delete account");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  /* =========================
     CHECK IF CHILD IS ACTIVE
  ========================= */
  const isChildActive = (children) => {
    return children.some(child => location.pathname === child.route);
  };

  /* =========================
     SIDEBAR HOVER HANDLERS
  ========================= */
  const handleSidebarMouseEnter = () => {
    if (!isOpen) {
      hoverTimerRef.current = setTimeout(() => {
        setIsHovering(true);
      }, 300); // 300ms delay before expanding
    }
  };

  const handleSidebarMouseLeave = () => {
    if (hoverTimerRef.current) {
      clearTimeout(hoverTimerRef.current);
    }
    setIsHovering(false);
  };

  /* =========================
     GET SIDEBAR CLASS
  ========================= */
  const getSidebarClass = () => {
    let baseClass = "pp-sidebar";
    baseClass += isOpen ? " pp-open" : " pp-closed";
    baseClass += isHovering && !isOpen ? " pp-hover-expand" : "";
    return baseClass;
  };

  /* =========================
     RENDER MENU ITEMS VARIOUS DATA THAT NOT APPROVED IN TE
  ========================= */
  /* =========================
   RENDER MENU ITEMS - FILTERED BY BUSINESS MODULES FOR EMPLOYEES
========================= */
  /* =========================
    RENDER MENU ITEMS - FILTERED BY BUSINESS MODULES FOR EMPLOYEES
 ========================= */
  const renderMenuItems = () => {
    // Get login data from localStorage
    const loginData = JSON.parse(localStorage.getItem("loginResponse"));
    const userRole = localStorage.getItem("role");
    const businessModules = loginData?.businessModules || [];
    const parentId = loginData?.parentId;

    // Check if user is an employee
    const isEmployee = userRole === "ROLE_EMPLOYEE";



    // Create a mapping from backend module to menu key
    const backendToMenuKey = {
      "DASHBOARD": "Home",
      "BUSINESS_PROFILE": "Company",
      "SETTINGS_CONTROLS": "Settings_Controls",
      "PRODUCTS_PRICES": "Menu_Management",
      "ORDER_MANAGEMENT": "Order_Management",
      "CHEF_MANAGEMENT": "Chef_Management",
      "SERVICE_MANAGEMENT": "Delivery_Management",
      "INVENTORY": "Inventory_Management",
      "TEAM_MANAGEMENT": "Team_Managment",
      "SALES_MANAGEMENT": "Sales_Management",
      "FINANCE_ACCOUNTING": "Account_History",
      "PROMOTIONS_MARKETING": "Promotions_Discounts",
      "REFER_EARN": "Refer_Earn",
      "REWARDS_COUPONS": "Rewards_Coupons",
      "RATINGS_REVIEWS": "Ratings_Reviews",
      "HELP_DESK": "Support_System",
      "LEGAL_COMPLIANCE": "Legal_Compliance",
      "NOTIFICATIONS": "Notification",
      "REPORTS_ANALYSIS": "Report_Analysis",
    };

    // Convert backend module names to menu keys
    const allowedMenuKeys = businessModules.map(module => {
      const menuKey = backendToMenuKey[module];
      return menuKey;
    }).filter(key => key);






    // Get all available menu items from enumToMenuItemMap
    const allMenuItems = Object.keys(enumToMenuItemMap);

    // Filter menu items based on user type
    const filteredMenuItems = Object.entries(enumToMenuItemMap)
      .filter(([key]) => {
        // Super Admin (parentId null or 0) → show all modules
        if (!parentId || parentId === 0) {
          // console.log("Super Admin - showing all modules");
          return true;
        }

        // For employees → show only allowed modules
        if (isEmployee) {
          // Check if this module key is in the allowed menu keys
          const isAllowed = allowedMenuKeys.includes(key);
          if (isAllowed) {
            // console.log(`✅ SHOWING: ${key} (${enumToMenuItemMap[key].text})`);
          } else {
            // console.log(`❌ HIDING: ${key} (${enumToMenuItemMap[key].text})`);
          }
          return isAllowed;
        }

        // For vendors (not employees) → show all modules
        return true;
      });

    // If no modules available for employee, show a message
    if (isEmployee && filteredMenuItems.length === 0) {
      return (
        <li className="pp-menu-item">
          <div className="pp-menu-link" style={{ color: '#999', cursor: 'default' }}>
            No modules assigned
          </div>
        </li>
      );
    }

    return filteredMenuItems.map(([key, item]) => {
      const Icon = item.icon;

      return (
        <li
          key={key}
          className={`pp-menu-item ${location.pathname === item.route ? "pp-active" : ""}`}
        >
          <Link to={item.route} className="pp-menu-link">
            <Icon />
            {(isOpen || isHovering) && <span>{item.text}</span>}
          </Link>
        </li>
      );
    });
  };

  return (
    <div className="pp-layout">
      {/* NAVBAR */}
      <header className="pp-top-navbar">
        <div className="pp-nav-left">
          <MenuIcon
            className="pp-nav-icon"
            onClick={() => setIsOpen(!isOpen)}
          />
          <h2 className="pp-logo-text">
            <span className="pp-black">M</span>
            <span className="pp-red">aa</span>
            <span className="pp-black">maas</span>
          </h2>
        </div>

        {/* LOCATION */}
        {/* Data not declaried LandingSideBar  */}
        {/* <div> Landingsiderbar Tablesnavbar MainfoldeFoodandbeverages, */}
        {/* <div className="pp-nav-center">
          <button
            className="pp-location-btn"
            onClick={() => setShowMapPopup(true)}
          >
            <LocationOnIcon />
            {selectedAddress
              ? selectedAddress.split(",").find(part => part.trim().toLowerCase().includes("hyderabad")) || selectedAddress.split(",")[selectedAddress.split(",").length - 4]
              : "Select Location"}
          </button>
        </div> */}

        {/* RIGHT */}
        <div className="pp-nav-right">
          {/* <NotificationsOutlinedIcon className="pp-nav-icon" /> */}

          <div className="pp-profile-wrapper" ref={profileRef}>
            <AccountCircleIcon
              className="pp-profile-icon"
              onClick={() => setProfileDropdown(!profileDropdown)}
            />
            {profileDropdown && (
              <div className="pp-profile-dropdown">
                {/* <div
                  className="pp-dropdown-item"
                  onClick={handleSubscription}
                  style={{ cursor: "pointer" }}
                >
                  Subscription
                </div> */}
                <div
                  className="pp-dropdown-item"
                  onClick={handleLogout}
                  style={{ cursor: "pointer" }}
                >
                  Logout
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* LOCATION POPUP */}
      {locationPopup && (
        <div className="pp-location-modal">
          <Paper
            elevation={4}
            sx={{
              width: "900px",
              display: "flex",
              overflow: "hidden",
              borderRadius: "12px",
            }}
          >
            <Box sx={{ width: "40%", p: 3 }}>
              <Typography variant="h6" mb={2}>
                Select Location
              </Typography>

              <Button
                variant="contained"
                fullWidth
                onClick={handleUseCurrentLocation}
                sx={{ mb: 2 }}
              >
                Use My Current Location
              </Button>

              <TextField
                fullWidth
                placeholder="Search address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                sx={{ mb: 2 }}
              />

              {currentLocation && (
                <Button fullWidth variant="contained" onClick={handleSaveAddress}>
                  Save Address
                </Button>
              )}
            </Box>

            <Box sx={{ width: "60%" }}>
              <MapContainer
                center={[mapCenter.lat, mapCenter.lng]}
                zoom={15}
                style={{ height: "500px", width: "100%" }}
              >
                <TileLayer
                  attribution="&copy; OpenStreetMap"
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {currentLocation && (
                  <Marker position={[currentLocation.lat, currentLocation.lng]} />
                )}
                <MapClickHandler />
              </MapContainer>
            </Box>
          </Paper>
        </div>
      )}

      {/* SIDEBAR */}
      <div
        ref={sidebarRef}
        className={getSidebarClass()}
        onMouseEnter={handleSidebarMouseEnter}
        onMouseLeave={handleSidebarMouseLeave}
      >

        <ul className="pp-menu">
          {renderMenuItems()}
        </ul>

      </div>

      {/* CONTENT */}
      <div className={`pp-content ${(isOpen || isHovering) ? "pp-content-shift" : ""}`}>
        {children}
      </div>
      {showLocationPopup && (
        <div style={styles.locationPopupOverlay}>
          <div style={styles.locationPopup}>

            <div style={styles.popupHeader}>
              <h2 style={styles.popupTitle}>Select Location</h2>
              <button
                style={styles.closePopupBtn}
                onClick={() => setShowLocationPopup(false)}
              >
                ✕
              </button>
            </div>

            {/* Search */}
            <div style={styles.searchContainer}>
              <input
                type="text"
                placeholder="Search for area or street"
                style={styles.popupSearchInput}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleAddressSearch();
                  }
                }}
              />
            </div>

            {/* Detect location */}
            <div style={styles.optionBox} onClick={getCurrentLocation}>
              <div>
                <h3 style={styles.optionTitle}>Use My Current Location</h3>
                <p style={styles.optionDesc}>
                  Detect your location automatically
                </p>
              </div>

              <button style={styles.enableBtn} disabled={isLocating}>
                {isLocating ? "Locating..." : "Detect"}
              </button>
            </div>

            {locationError && (
              <div style={styles.errorMessage}>
                {locationError}
              </div>
            )}

            {/* Saved Addresses */}
            {savedAddresses.map((item, index) => (
              <div
                key={index}
                style={styles.savedBox}
                onClick={() => {
                  setSelectedAddress(item.full);
                  localStorage.setItem("selectedAddress", item.full);
                  setShowLocationPopup(false);
                }}
              >
                {item.title} - {item.full}
              </div>
            ))}

          </div>
        </div>
      )}

      {/* Map Popup */}
      {showMapPopup && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
          padding: "20px",
          boxSizing: "border-box",
        }}>
          <div style={{
            width: "100%",
            maxWidth: "700px",
            height: "100%",
            background: "#fff",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            boxShadow: "0 10px 25px rgba(0,0,0,0.25)"
          }}>
            {/* Header */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #ddd",
            }}>
              <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>Select Location on Map</h2>
              <button
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  lineHeight: 1
                }}
                onClick={() => {
                  setShowMapPopup(false);
                  setMapSelectedLocation(null);
                  setMapAddress("");
                  setAddressTitle("");
                  if (window.currentMap) { window.currentMap.remove(); window.currentMap = null; }
                  if (window.currentMarker) { window.currentMarker = null; }
                }}
              >✕</button>
            </div>

            {/* Map */}
            <div style={{ flex: 1, position: "relative", display: "flex", flexDirection: "column" }}>
              <div ref={mapRef} style={{
                flex: 1,
                width: "100%",
                minHeight: "300px",
                background: "#f0f0f0",
                position: "relative"
              }}>
                {!window.L && (
                  <div style={{
                    position: "absolute",
                    top: 0, left: 0, right: 0, bottom: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#666",
                    fontSize: "16px"
                  }}>
                    <div style={{
                      width: "24px",
                      height: "24px",
                      border: "3px solid #ccc",
                      borderTop: "3px solid #333",
                      borderRadius: "50%",
                      marginRight: "8px",
                      animation: "spin 1s linear infinite"
                    }}></div>
                    Loading map...
                  </div>
                )}
              </div>

              {/* Controls */}
              <div style={{
                padding: "12px 16px",
                borderTop: "1px solid #ddd",
                display: "flex",
                flexDirection: "column",
                gap: "10px"
              }}>
                {/* Address display */}
                <div style={{
                  minHeight: "24px",
                  color: "#333",
                  fontSize: "14px",
                }}>
                  {isMapLoading
                    ? <span>Getting address...</span>
                    : mapAddress || "Click on the map to select a location"}
                </div>

                {/* Address title input */}
                <input
                  type="text"
                  placeholder="Address Title (e.g., Home, Office)"
                  style={{
                    padding: "8px 10px",
                    fontSize: "14px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                  value={addressTitle}
                  onChange={(e) => setAddressTitle(e.target.value)}
                />
                <button
                  style={{
                    padding: "10px",
                    background: "#007bff",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                  onClick={handleGetCurrentLocationFromMap}
                >
                  📍 Use Current Location
                </button>
                {/* Save Address Button */}
                <button
                  style={{
                    padding: "10px 0",
                    fontSize: "16px",
                    borderRadius: "6px",
                    border: "none",
                    background: mapSelectedLocation && mapAddress ? "#ff0054" : "#ccc",
                    color: "#fff",
                    cursor: mapSelectedLocation && mapAddress ? "pointer" : "not-allowed",
                    transition: "0.2s",
                  }}
                  disabled={!mapSelectedLocation || !mapAddress}
                  onClick={handleSaveAddressFromMap}
                  onMouseEnter={(e) => {
                    if (mapSelectedLocation && mapAddress) {
                      e.target.style.background = "#e0004a";
                      e.target.style.transform = "translateY(-2px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (mapSelectedLocation && mapAddress) {
                      e.target.style.background = "#ff0054";
                      e.target.style.transform = "translateY(0)";
                    }
                  }}
                >
                  Save Address
                </button>
              </div>
            </div>
          </div>

          {/* Spinner keyframes */}
          <style>{`
                          @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                          }
                        `}</style>
        </div>
      )}
    </div>
  );
};
const styles = {
  section: {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#b15cd6",
  },
  navbar: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 20px",
    backgroundColor: "#b15cd6",
    zIndex: 1000,
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },
  logo: {
    fontSize: "30px",
    fontWeight: "bold",
    fontFamily: "roboto",
    color: "white",
    cursor: 'pointer',
    marginRight: "20px",
    flexShrink: 0,
  },
  mobileIconsContainer: {
    // display: isMobile && isLoggedIn ? "flex" : "none",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: "10px",
  },
  navButtons: {
    // display: isMobile ? "none" : "flex",
    alignItems: "center",
    gap: "15px",
  },
  mobileMenuButtons: {
    // display: isMobile && showMobileMenu ? "flex" : "none",
    flexDirection: "column",
    position: "absolute",
    top: "60px",
    right: "10px",
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    padding: "15px",
    zIndex: 1001,
    width: "180px",
  },
  navButton: {
    backgroundColor: "transparent",
    color: "white",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    cursor: "pointer",
    padding: "8px 12px",
    borderRadius: "5px",
    transition: "all 0.3s ease",
    textAlign: "left",
    width: "100%",
  },
  mobileMenuButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "white",
    fontSize: "24px",
    cursor: "pointer",
    // display: isMobile ? "block" : "none",
    marginLeft: "10px",
  },
  locationWrapper: {
    // display: isMobile ? "none" : "flex",
    alignItems: "center",
    gap: "15px",
    flex: 1,
    maxWidth: "600px",
    marginLeft: "40px",
    marginRight: "20px",
  },
  mobileLocationWrapper: {
    // display: isMobile ? "flex" : "none",
    alignItems: "center",
    gap: "10px",
    marginLeft: "auto",
  },
  locationBox: {
    display: "flex",
    alignItems: "center",
    background: "white",
    color: "#333",
    padding: "8px 16px",
    borderRadius: "20px",
    cursor: "pointer",
    gap: "8px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
    minWidth: "220px",
    flexShrink: 0,
  },
  mobileLocationIcon: {
    display: "flex",
    alignItems: "center",
    color: "#333",
    padding: "8px",
    borderRadius: "50%",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  locationIcon: {
    fontSize: "18px",
    color: "#ff0054"
  },
  locationText: {
    fontWeight: 600,
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "150px"
  },
  downArrow: {
    fontSize: "12px",
    marginLeft: "5px",
    color: "#666"
  },
  mobileSearchContainer: {
    position: "fixed",
    top: "60px",
    left: 0,
    width: "100%",
    backgroundColor: "white",
    padding: "15px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    zIndex: 999,
    // display: isMobile && showMobileSearch ? "flex" : "none",
    alignItems: "center",
    gap: "10px",
  },
  mobileSearchInput: {
    flex: 1,
    padding: "12px 16px",
    borderRadius: "20px",
    border: "1px solid #ddd",
    fontSize: "16px",
    outline: "none",
  },
  locationPopupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  locationPopup: {
    background: "white",
    width: "450px",
    borderRadius: "20px",
    padding: "20px",
    maxHeight: "85vh",
    overflowY: "auto",
    scrollbarWidth: 'none',
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },
  popupHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
    paddingBottom: "15px",
    borderBottom: "1px solid #eee",
  },
  popupTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "700",
    color: "#333",
  },
  closePopupBtn: {
    cursor: "pointer",
    fontSize: "20px",
    color: "#666",
    background: "none",
    border: "none",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    background: "#f7f7f7",
    borderRadius: "12px",
    padding: "12px 15px",
    marginBottom: "20px",
  },
  searchIcon: {
    marginRight: "10px",
    color: "#666",
    fontSize: "18px"
  },
  popupSearchInput: {
    border: "none",
    outline: "none",
    width: "100%",
    background: "transparent",
    fontSize: "16px",
  },
  optionBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "white",
    borderRadius: "15px",
    padding: "18px",
    border: "1px solid #eee",
    marginBottom: "15px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  optionContent: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  optionTitle: {
    color: "#333",
    margin: 0,
    fontSize: "16px",
    fontWeight: "600"
  },
  optionDesc: {
    color: "#666",
    margin: "5px 0 0 0",
    fontSize: "14px"
  },
  enableBtn: {
    border: "1px solid #ff0054",
    background: "white",
    color: "#ff0054",
    padding: "8px 16px",
    borderRadius: "20px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    transition: "all 0.3s ease",
  },
  addAddressBox: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "18px",
    background: "white",
    borderRadius: "15px",
    border: "1px solid #eee",
    cursor: "pointer",
    marginBottom: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    transition: "all 0.3s ease",
  },
  plusIcon: {
    fontSize: "20px",
    color: "#ff0054",
  },
  addAddressText: {
    color: "#ff0054",
    fontSize: "16px",
    fontWeight: "600",
  },
  savedHeading: {
    marginTop: "25px",
    marginBottom: "15px",
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
  },
  savedBox: {
    display: "flex",
    gap: "15px",
    padding: "16px",
    borderRadius: "15px",
    background: "white",
    border: "1px solid #eee",
    marginBottom: "12px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  },
  savedTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#333"
  },
  savedAddressText: {
    margin: "5px 0 0 0",
    fontSize: "14px",
    color: "#666",
    lineHeight: "1.4"
  },
  loadingSpinner: {
    display: "inline-block",
    width: "20px",
    height: "20px",
    border: "3px solid rgba(255,0,84,0.3)",
    borderRadius: "50%",
    borderTopColor: "#ff0054",
    animation: "spin 1s ease-in-out infinite",
    marginRight: "10px",
  },
  errorMessage: {
    color: "#ff0054",
    fontSize: "14px",
    textAlign: "center",
    margin: "10px 0",
    padding: "10px",
    backgroundColor: "#fff5f5",
    borderRadius: "8px",
  },
};
export default PremiumProfessionalLayout;